import React from 'react';
import { useTranslation } from 'react-i18next';
import './publicAnnouncementDetails.css';
import { Alert, Form } from 'react-bootstrap';
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';
import Moment from 'moment';
import PreloaderComponent from '../../commons/preloader/preloaderComponent';

const PublicAnnouncementDetailsView = ({
    announcement,
    message,
    success,
    isLoading,
    setLanguage,
    language,
}) => {
    const { t } = useTranslation();
    if (isLoading) {
        return <PreloaderComponent />;
    }

    // Fall back to the Finnish version when the selected language has no
    // content, so an English-UI visitor isn't shown an empty announcement.
    const content =
        announcement['content' + language] || announcement.contentFI;
    const title = announcement['title' + language] || announcement.titleFI;
    const firstName = announcement.announcer.firstName;
    const lastName = announcement.announcer.lastName;
    const photoUrl =
        announcement.announcer.photoUrl ??
        'https://eu.ui-avatars.com/api/?name=' +
            firstName +
            '+' +
            lastName +
            '&size=50&bold=true&length=2&format=png';

    return (
        <div className="announcement-form">
            <div id="editor"></div>
            {message && !success ? (
                <Alert variant={!success ? 'danger' : 'success'}>
                    {t(message.key, message.params)}
                </Alert>
            ) : null}
            <div className="language-row">
                <Form.Control
                    as="select"
                    className="language-select"
                    value={language}
                    onChange={(e) => {
                        e.preventDefault();
                        setLanguage(e.target.value);
                    }}
                >
                    <option value="FI">{t('announcements.finnish')}</option>
                    <option value="EN">{t('announcements.english')}</option>
                </Form.Control>
            </div>
            {!isLoading && title ? <h2>{title}</h2> : null}

            <div className="details-row">
                <p>{Moment(announcement.publishedAt).format('D.M.YYYY')}</p>
                {announcement.announcer && (
                    <div className="announcer">
                        <p>
                            {firstName}
                            <br></br>
                            {lastName}
                        </p>
                        <img src={photoUrl} alt="img"></img>
                    </div>
                )}
            </div>
            {!isLoading && content ? (
                <ReactQuill
                    theme="snow"
                    value={content}
                    readOnly={true}
                    modules={{ toolbar: false }}
                />
            ) : (
                <p>{t('announcements.noContent')}</p>
            )}
            <h5>{t('announcements.attachments')}</h5>
            {announcement.attachments &&
                announcement.attachments.length <= 0 && (
                    <p>{t('announcements.noAttachments')}</p>
                )}
            {announcement.attachments &&
                announcement.attachments.map((a) => (
                    <a className="attachment-link" href={a.path} key={a.name}>
                        {a.name}
                    </a>
                ))}
        </div>
    );
};

export default PublicAnnouncementDetailsView;
